
import picture from '../assets/img/georgino_picture.png';
function PageNotFound() {
    return(
        
        <section>
            <div className="text-center">
                <img 
                    src={picture}
                    alt="Gino"
                    width="340"
                    className="mt-4 mb-3"/>

                <h1>404 NOT FOUND</h1>
            </div>
        </section>
    );
}

export default PageNotFound